/* eslint react/jsx-indent: 0 */
/* eslint import/namespace: ['error', { allowComputed: true }] */
import React from 'react'
import _cx from 'classnames/bind'
// @ts-ignore no types
import { connect } from 'react-redux'
import {
  Text,
  hooks,
  // @ts-ignore no types
} from '@adc/ui-adc'
import PopupTooltip from '../../components/popupTooltip'
// @ts-ignore no types
import cls from './index.scss'

const cx = _cx.bind(cls)

type TitleStatusType = {
  title: string
  status: JSX.Element
  elmId: string
  tooltipMessage: string
}

const TitleStatus = ({
  title,
  status,
  elmId,
  tooltipMessage,
}: TitleStatusType) => {
  const isMobile = hooks.useIsMobileHook()
  return (
    <div
      className={cx({
        'u-mt-4': !isMobile,
        'u-mb-4': !isMobile,
        'u-mb-2': isMobile,
      })}
    >
      <Text
        data-elm-id={`${elmId}_label`}
        size={isMobile ? 'tiny' : 'large'}
        color={isMobile ? 'gray' : 'grayDark'}
      >
        {title}
      </Text>
      <Text
        data-elm-id={`${elmId}_status`}
        weight='heavy'
        color='gray'
        size={isMobile ? 'tiny' : 'large'}
      >
        {tooltipMessage ? (
          <PopupTooltip
            content={tooltipMessage}
            elmId={`${elmId}_tooltip`}
            position='top left'
            trigger={<span className={cx('dashed-link')}>{status}</span>}
          />
        ) : (
          <span>{status}</span>
        )}
      </Text>
    </div>
  )
}

export default TitleStatus
